import { AddressDto } from 'src/app/entity/addressDto';
import { CustomerDetailDto } from './customerDetailDto';
import { LicenceTableDto } from './licenceTableDto';
import { ContactDto } from './contactDto';

export class CustomerWizardDto {
  customer: CustomerDetailDto;
  address: AddressDto;
  contact: ContactDto;
  licences: LicenceTableDto[];
}
